export class ArrayValidators {

	/**
	 * Validateur considérant que le formcontrol est valid si un prédicat est vérifié pour l'ensemble de ses valeurs
	 * @param validator le prédicat
	 * @param nomErreur le nom de l'erreur
	 */
	static forEach(validator: Function, nomErreur: string) {
		return (formControl => {
			if (!formControl.parent) {
				return null;
			}

			const resultatErreur = {};
			resultatErreur[nomErreur] = true;

			if (Array.isArray(formControl.value)) {
				return formControl.value.some(valeur => !validator(valeur)) ?
					resultatErreur :
					null;
			}
			return null;
		});
	}
}
